// extracted by mini-css-extract-plugin
export var masthead = "MastheadNewsletter-module--masthead--OjJZU";
export var contentContainer = "MastheadNewsletter-module--contentContainer--2P9x1";
export var title = "MastheadNewsletter-module--title--1HUOH";
export var showFadeInUp = "MastheadNewsletter-module--show-fade-in-up--q4w8Z";
export var author = "MastheadNewsletter-module--author--2saF6";
export var name = "MastheadNewsletter-module--name--3U9HK";
export var show = "MastheadNewsletter-module--show--1Xb6Y";
export var showFadeInDown = "MastheadNewsletter-module--show-fade-in-down--BObRZ";
export var hideFadeOut = "MastheadNewsletter-module--hide-fade-out--3udrv";